var _ellipse, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0716,
    cy: 13.5414,
    rx: 13.0716,
    ry: 13.5414,
    fill: "#F4F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19H7.25C7.25 19.4142 7.58579 19.75 8 19.75V19ZM8 16.1765L7.46967 15.6461C7.32902 15.7868 7.25 15.9776 7.25 16.1765H8ZM17.1765 7L17.7068 6.46967C17.5661 6.32902 17.3754 6.25 17.1765 6.25C16.9776 6.25 16.7868 6.32902 16.6461 6.46967L17.1765 7ZM20 9.82353L20.5303 10.3539C20.671 10.2132 20.75 10.0224 20.75 9.82353C20.75 9.62462 20.671 9.43385 20.5303 9.2932L20 9.82353ZM10.8235 19V19.75C11.0224 19.75 11.2132 19.671 11.3539 19.5303L10.8235 19ZM8.75 19V16.1765H7.25V19H8.75ZM16.6461 7.53033L19.4697 10.3539L20.5303 9.2932L17.7068 6.46967L16.6461 7.53033ZM10.8235 18.25H8V19.75H10.8235V18.25ZM19.4697 9.2932L17.352 11.4108L18.4127 12.4715L20.5303 10.3539L19.4697 9.2932ZM17.352 11.4108L10.2932 18.4697L11.3539 19.5303L18.4127 12.4715L17.352 11.4108ZM8.53033 16.7068L15.5892 9.64798L14.5285 8.58732L7.46967 15.6461L8.53033 16.7068ZM15.5892 9.64798L17.7068 7.53033L16.6461 6.46967L14.5285 8.58732L15.5892 9.64798ZM18.4127 11.4108L15.5892 8.58732L14.5285 9.64798L17.352 12.4715L18.4127 11.4108Z",
    fill: "#757575"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d959dfac2f3d0149540a6949f7c27553.svg";
export { ForwardRef as ReactComponent };